export interface IAutoTagContent {
  headline: string;
  standfirst: string;
  body: string;
}

// Replicates the backend content hash exactly (smart-linking-api contract.py / cms-api
// SmartLinkingHash + SmartLinkingProxy.StripHtml) so the panel can tell when the article has been
// edited since it was tagged. The body is HTML-stripped then entity-decoded (as cms-api does
// before hashing); headline and standfirst are hashed as-is. The three fields are joined with a
// newline, normalised (trim, collapse whitespace, lower-case) and SHA-256 hex encoded.
export async function autoTagContentHash(
  content: IAutoTagContent,
): Promise<string> {
  const body = decodeHtmlEntities(stripHtmlTags(content.body ?? ''));
  const normalised = normalise(
    `${content.headline ?? ''}\n${content.standfirst ?? ''}\n${body}`,
  );
  return sha256Hex(normalised);
}

function stripHtmlTags(html: string): string {
  return html.replace(/<[^>]+>/g, ' ');
}

function decodeHtmlEntities(value: string): string {
  const el = document.createElement('textarea');
  el.innerHTML = value;
  return el.value;
}

function normalise(value: string): string {
  return value.trim().replace(/\s+/g, ' ').toLowerCase();
}

async function sha256Hex(value: string): Promise<string> {
  const bytes = new TextEncoder().encode(value);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}
